import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import LinkIcon from '@material-ui/icons/Link'
const useStyles = createUseStyles(
  {
    'anchor-parent': {
      fontSize: '1.75rem',
      alignItems: 'center',
      display: 'flex'
    },
    anchor: {
      marginRight: '1.5rem',
      textDecoration: 'none'
    }
  },
  { name: 'bund-' }
)

export const Anchor = (props) => {
  const {
    children,
    icon,
    className,
    style,
    disabled = false,
    href,
    ariaLabel,
    ...rest
  } = props
  const classes = useStyles()

  return (
    <span
      style={style}
      className={clsx(classes['anchor-parent'], className)}
      disabled={disabled}
      {...rest}>
      <a
        href={href}
        aria-label={ariaLabel}
        style={style}
        className={clsx(classes.anchor, className)}
        disabled={disabled}
        {...rest}>
        {!icon ? (
          <span>
            <LinkIcon />
          </span>
        ) : (
          icon && <span> {icon}</span>
        )}
      </a>{' '}
      {children}
    </span>
  )
}

Anchor.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * The URL to link to when the anvhor is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.string
  ])
}

Anchor.displayName = 'a'

export default Anchor
